import * as types from "./actionTypes";
import * as tenantApi from "../../api/tenantApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import * as notifications from "./notificationsActions";
import { claimAccessRenewal } from "../../utils/tenantAccessGuard";

export function readTenantSuccess(tenant) {
    return { type: types.READ_TENANT_SUCCESS, tenant };
}
export function getAllAvailableTenantsSuccess(tenants) {
    return { type: types.GET_ALL_AVAILABLE_TENANTS_SUCCESS, tenants };
}

export function readTenant(tenantId) {
    return function(dispatch) {
        dispatch(beginApiCall());
        return tenantApi
            .readTenant(tenantId)
            .then(tenant => {
                sessionStorage.setItem("tenant_id", tenantId);
                localStorage.setItem("tenant_id", tenantId);
                dispatch(readTenantSuccess(tenant));
            })
            .catch(error => {
                sessionStorage.removeItem("tenant_id");
                localStorage.removeItem("tenant_id");
                dispatch(apiCallError(error));
                dispatch(notifications.notificationError("ErrorGettingTenantId"));
            });
    };
} 
export function getAllAvailableTenants() {
    return function(dispatch) {
        dispatch(beginApiCall());
        return tenantApi
            .getAllAvailableTenants()
            .then(tenant => {
                dispatch(getAllAvailableTenantsSuccess(tenant));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                dispatch(notifications.notificationError("ErrorGettingTenants"));
            });
    };
} 


export function selectTenantSuccess(tenantId) {
    return function(dispatch) {
        const action = { type: types.SELECT_TENANT_SUCCESS, tenantId };
        dispatch(action);
    }
}

export function selectTenant(tenantId, availableTenants, renewAccess) {
    return function (dispatch) {
        // A requested tenant ("?tenant=" in a link, the redirect from the sugar login page,
        // or the one remembered from an earlier login - maybe with another account) is only
        // opened when the signed in account actually has it. Otherwise the account's own
        // default tenant is opened instead of a tenant every request then answers 401 for.
        if (!!tenantId && !!availableTenants && availableTenants.length > 0
            && !availableTenants.find(tenant => tenant.id === tenantId)) {
            // The tenant list follows the groups in the access token. An account added to
            // the tenant after the token was issued gets it once the token is renewed, so
            // renew once and ask again before giving up on the tenant.
            if (typeof renewAccess === 'function' && claimAccessRenewal(tenantId)) {
                return Promise.resolve()
                    .then(() => renewAccess())
                    .then(() => tenantApi.getAllAvailableTenants(true))
                    .then(tenants => {
                        const renewed = Array.isArray(tenants) && tenants.length > 0 ? tenants : availableTenants;
                        // Select before publishing the list: the selector reacts to a longer
                        // list by selecting again, and the tenant is then already open.
                        dispatch(selectTenant(tenantId, renewed));
                        if (renewed !== availableTenants) {
                            dispatch(getAllAvailableTenantsSuccess(renewed));
                        }
                    })
                    .catch(() => dispatch(selectTenant(tenantId, availableTenants)));
            }
            forgetStoredTenant(tenantId);
            dispatch(notifications.notificationWarning("NoAccessToTenant"));
            dispatch(selectDefaultTenant(availableTenants));
        } else if (!!tenantId) {
            dispatch(readTenant(tenantId));
            dispatch(selectTenantSuccess(tenantId));
        } else {
            dispatch(selectDefaultTenant(availableTenants));
        }
    };
}

function forgetStoredTenant(tenantId) {
    if (sessionStorage.getItem("tenant_id") === tenantId) {
        sessionStorage.removeItem("tenant_id");
    }
    if (localStorage.getItem("tenant_id") === tenantId) {
        localStorage.removeItem("tenant_id");
    }
}

export function tenantAccessDenied(tenantId) {
    return { type: types.TENANT_ACCESS_DENIED, tenantId };
}

export function tenantAccessConfirmed(tenantId) {
    return { type: types.TENANT_ACCESS_CONFIRMED, tenantId };
}

export function selectDefaultTenant(availableTenants) {
    return function (dispatch) {
        if (!availableTenants || availableTenants.length === 0) {
            dispatch(notifications.notificationError("ErrorGettingTenants"));
            return;
        }

        // Select the previously selected tenant if set in localstorage
        var tenantId = sessionStorage.getItem("tenant_id");
        if (!tenantId) {
            tenantId =  localStorage.getItem("tenant_id");
        }
        if (!tenantId) {
            // Fist available tenant is selected as the default tenant
            tenantId = availableTenants[0].id;
        } else if (!!tenantId && 
            !availableTenants.find(tenant => tenant.id === tenantId)) {
                // If the previously selected tenant is not available any more
                // select the first available tenant.
                tenantId = availableTenants[0].id;
        }

        dispatch(readTenant(tenantId));
    };
}

export function tenantSessionActivated(tenantId) {
    return function(dispatch) {
        const action = { type: types.TENANT_SESSION_ACTIVATED, tenantId };
        dispatch(action);

    }
}

export function tenantSessionDeactivated(tenantId) {
    return function(dispatch) {
        const action = { type: types.TENANT_SESSION_DEACTIVATED, tenantId };
        dispatch(action);
        
    }
}

